import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { FicheFacturationSaisie } from '@artosera/shared';
import { api } from './client.js';
import { useMutation } from './mutation.js';
import { appelDeRequete, cleMetier, dansLaPortee } from './cles.js';
import { modeDemonstrationActif } from './demo.js';

export interface FicheFacturationArtosera {
  ficheFacturation:
    | (FicheFacturationSaisie & {
        tvaVerifieeLe?: string;
        tvaVerifieePar?: 'verificateur' | 'console';
      })
    | null;
  revisionFicheFacturation: number;
}
export function useFicheFacturationArtosera(galerie: string, autorise: boolean) {
  return useQuery({
    queryKey: cleMetier(galerie, 'facturation-artosera'),
    queryFn: (contexte): Promise<FicheFacturationArtosera> =>
      modeDemonstrationActif()
        ? Promise.resolve({ ficheFacturation: null, revisionFicheFacturation: 0 })
        : api.get(`/g/${encodeURIComponent(galerie)}/reglages/facturation-artosera`, {
            galerie,
            ...appelDeRequete(contexte),
          }),
    enabled: autorise,
  });
}
export function useEcrireFicheFacturationArtosera(galerie: string) {
  const client = useQueryClient();
  return useMutation(
    dansLaPortee({
      mutationFn: (corps: FicheFacturationSaisie & { revisionFicheFacturation: number }, appel) => {
        if (modeDemonstrationActif()) throw new Error('demo');
        return api.put<FicheFacturationArtosera>(
          `/g/${encodeURIComponent(galerie)}/reglages/facturation-artosera`,
          corps,
          { galerie, ...appel },
        );
      },
      onSuccess: (donnees) => {
        client.setQueryData(cleMetier(galerie, 'facturation-artosera'), donnees);
      },
    }),
  );
}
